
namespace Gamification.Gamification {
    export class UtentiApiColumns {
        static columnsKey = 'Gamification.UtentiApi';
    }
}